module.exports = __webpack_public_path__ + "static/media/face.74edadd6.jpg";